export default "__VITE_ASSET__74f354c5__"